import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import shops from '../../../../assets/images/ecp/online-shops.svg';

export const useStyles = makeStyles(({
  breakpoints,
  palette,
}: Theme) => ({
  root: {
    padding: '1.25rem 0 4rem',
    [breakpoints.up('sm')]: {
      padding: '0.5rem 0 3rem',
    },
  },
  points: {
    margin: '0 0 1rem',
    padding: '0.75rem 0.75rem 0.75rem 4.5rem',
    borderRadius: '0.5rem',
    background: `${palette.secondary.light} url(${shops}) no-repeat 0.75rem 0.75rem`,
    backgroundSize: '3rem',
  },
}));
